var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.513.386l1.928 5.983 6.023.073c.518.006.732.698.317 1.022l-4.832 3.77 1.795 6.027c.154.519-.407.946-.83.632L9 14.24l-4.914 3.652c-.422.314-.984-.114-.83-.632l1.795-6.027L.22 7.463C-.197 7.14.018 6.448.536 6.442l6.023-.073L8.487.386a.534.534 0 011.026 0z","fill":"#FFF","fillRule":"evenodd"}));
}

Star.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = Star;

Star.default = Star;
